import { Component, Injector, Input, Optional } from '@angular/core';

import { PakbonService } from 'src/app/core/service/pakbon.service';
import { Pakbon } from 'src/app/core/dto/pakbon';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType, FilterMethod, FilterProperty } from '@mango/core';
import { Project } from 'src/app/core/dto/project';
import { WithoutValidationMessage } from 'src/app/core/utils/string';
import { Router } from '@angular/router';

@Component({
    selector: 'c-i-j-borculo-factureren-collection',
    templateUrl: './factureren-collection.component.html'/*,
    styleUrls: ['./pakbon-collection.component.css'] */
})
export class FacturerenCollectionComponent extends PagedCollectionComponent<Pakbon> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Pakbon>([
		{ colDef: 'pakbonnummer', prop: x => x.pakbonnummer, searchable: SearchableType.String },
		{ colDef: 'datumPakbon', prop: x => x.datumPakbon, searchable: SearchableType.Date },
        { colDef: 'groep', prop: x => x.project.projectgroep.afdeling, searchable: SearchableType.String },
        { colDef: 'project', prop: x => x.project.code, searchable: SearchableType.String },		
        { colDef: 'klant', prop: x => x.project.relatie.naam1, searchable: SearchableType.String },		
        { colDef: 'referentieKlant', prop: x => x.project.referentieKlant, searchable: SearchableType.String },
        { colDef: 'verzendtarief', prop: x => x.verzendtarief.omschrijving, searchable: SearchableType.String },				
		{ colDef: 'verzendbedrag', prop: x => x.verzendbedrag, searchable: SearchableType.Number },
        { colDef: 'wachtOpPrijs', prop: x => x.wachtOpPrijs, searchable: SearchableType.Number },        
        { colDef: 'opmerking', prop: x => x.opmerking, searchable: SearchableType.String },
        { colDef: 'aantalPakbonregels', prop: x => x.aantalPakbonregels, searchable: SearchableType.Number },
        { colDef: 'proFormaTerGoedkeuring', prop: x => x.project.relatie.proFormaTerGoedkeuring, searchable: SearchableType.Boolean },
        { colDef: 'proFormaVoorInkoop', prop: x => x.project.relatie.proFormaVoorInkoop, searchable: SearchableType.Boolean },
        { colDef: 'hasProFormaFactuur', prop: x => x.hasProFormaFactuur, searchable: SearchableType.Boolean }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: PakbonService, @Optional() protected filter: Filter<Pakbon>, injector: Injector, private route:Router) {
        super('/pakbon/factureren', injector, Pakbon);
        
        this.filter.add(this.filterBuilder.equal(x => x.teFactureren, 0),true);
        // Sorteren op DatumMail ASC
        this.orderBy = [-2];

        this.initCustomActions();

        this.filter.onGetChipLabel(x => x.pakbonnummer, () => 'Pakbonnummer');
        this.filter.onGetChipLabel(x => x.datumPakbon, () => 'Datum pakbon');
        this.filter.onGetChipLabel(x => x.project.code, () => 'Project');
        this.filter.onGetChipLabel(x => x.project.relatie.naam1, () => 'Klant');
        this.filter.onGetChipLabel(x => x.verzendtarief.omschrijving, () => 'Verzendtarief');
        this.filter.onGetChipLabel(x => x.verzendbedrag, () => 'Verzendbedrag');
        this.filter.onGetChipLabel(x => x.wachtOpPrijs, () => 'Wacht op Prijs');
        this.filter.onGetChipLabel(x => x.opmerking, () => 'Opmerking');
        this.filter.onGetChipLabel(x => x.aantalPakbonregels, () => 'Aantal pakbonregels');
        this.filter.onGetChipLabel(x => x.hasProFormaFactuur, () => 'ProForma');
    }

    displayColumn(colDef: ColumnDefinition, ix: number) {
		// Hide columns that are needed for calculations
        if(colDef.colDef == 'aantalPakbonregels' ) { return false; }
        
		return super.displayColumn(colDef, ix);
	}

    private _project: Project;

    @Input() set project(val: Project) {
        this.handleInput('project', val.id);
        this._project = val;
    }
       
    canDelete() {
        return false;
    }

    initCustomActions() {

        this.buildCustomActions(config => {
            this.addSimpleMultiSelectAction({
                config,
                show: this.authScheme.canDo("CIJBorculo.Logic.CreateFactuurRequest"),
                fn: (items: Pakbon[]) => {
                        this.CreateFactuur(items,false);
                        return true;
                },
                icon: 'request_quote',
                title: 'Factuur',
                pin:true,
                isSelectable: item => (item.aantalPakbonregels > 0 && item.wachtOpPrijs == 0)
            })

        });

        this.buildCustomActions(config => {
            this.addSimpleMultiSelectAction({
                config,
                show: this.authScheme.canDo("CIJBorculo.Logic.CreateFactuurRequest"),
                fn: (items: Pakbon[]) => {
                        this.CreateFactuur(items,true);
                        return true;
                },
                icon: 'insert_drive_file',
                title: 'Proforma',
                pin:true,
                isSelectable: item => (item.aantalPakbonregels > 0 && item.wachtOpPrijs == 0)
            })

        });
    }

    async CreateFactuur(items: Pakbon[], proforma:boolean)
    {
        this.service.createFacturen(items, proforma).toPromise().then(
            (value) => { 
                if (value.successful) {
                    this.route.navigate(['/factuur/goedkeuren']);
                } else {
                    this.dialogs.snack("De facturatie is niet gelukt!");
                }
            }).catch((value) =>
            this.dialogs.snackError(WithoutValidationMessage(value.error.message))
        );
        
    }

}